import { render, staticRenderFns } from "./assisted.vue?vue&type=template&id=2ecd1ddc&scoped=true"
import script from "./assisted.vue?vue&type=script&lang=js"
export * from "./assisted.vue?vue&type=script&lang=js"
import style0 from "./assisted.vue?vue&type=style&index=0&id=2ecd1ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd1ddc",
  null
  
)

export default component.exports